module.exports = __webpack_public_path__ + "static/media/imagem42.edec6d83.jpeg";